export type Status = "not_started" | "in_progress" | "in_review" | "needs_changes" | "accepted";

/** Статусы из CLAUDE.md: точка + подпись, не только цвет. */
export const STATUS_LABEL: Record<Status, string> = {
  not_started: "не начато",
  in_progress: "в работе",
  in_review: "на проверке",
  needs_changes: "нужны правки",
  accepted: "принято",
};

const look: Record<Status, string> = {
  not_started: "bg-transparent text-mut border-bd",
  in_progress: "bg-accsoft text-acc border-accdim",
  in_review: "bg-warnsoft text-warn border-warn",
  needs_changes: "bg-errsoft text-err border-err",
  accepted: "bg-oksoft text-ok border-ok",
};

export function StatusChip({ status, compact = false }: { status: Status; compact?: boolean }) {
  return (
    <span
      data-status={status}
      className={`inline-flex items-center gap-1.5 rounded-sm border font-mono ${compact ? "px-2 py-[3px] text-[11px]" : "px-2.5 py-1 text-[11.5px]"} ${look[status]}`}
    >
      {!compact && <span aria-hidden className="size-1.5 rounded-full bg-current" />}
      {STATUS_LABEL[status]}
    </span>
  );
}
